import React, {useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Variables from "./variables/Variables";
import LowCodeActivities from "./LowCodeActivities";
import LibraryList from "./LibraryList";

const useStyles = makeStyles(() => ({
    root: {
        height: "90vh",
        background: "#FFFFFF",
        boxShadow: " 0px 0px 8px -3px rgba(0, 0, 0, 0.25)",
        borderRadius: "5px",
        margin: "37px 20px 20px 20px",
        //  overflowY: "scroll",
        paddingTop: "10px",
        overflow: 'auto'
    },
    heading: {
        fontSize: "12px",
        fontWeight: "bold",
        color: "#8C90A2",
    },
    headingActive: {
        fontSize: "12px",
        fontWeight: "bold",
        color: "#fff",
    }
}));



function LeftSideBar(props) {
    const {
        id,
        setVariables,
        variables,
        setOpenVariable,
        openVariable,
        setVariableRender,
        libraryData
    } = props;
    const [changeIcon, setChangeIcon] = useState(true);
    const [expandedMain, setExpandedMain] = useState(true);
    const [expanded, setExpanded] = useState(3);
    const classes = useStyles();

    return (
        <div
            className={classes.root}
            id="left-side-navs"
        >
            <Variables
                setVariableRender={setVariableRender}
                automId={id}
                open={openVariable}
                setOpen={setOpenVariable}
                expandedMain={expandedMain}
                setExpandedMain={setExpandedMain}
                variables={variables}
                setChangeIcon={setChangeIcon}
                setVariables={setVariables}
            />
            {libraryData && libraryData.length > 0 && libraryData.map((item,index) =>
                <LibraryList key={index} data={item}  libraryIndex={index} setExpandedMain={setExpanded} expandedMain={expanded}/>
            )}
            <div style={{marginBottom: 7}}>
                <LowCodeActivities expandedMain={expandedMain}
                                   setExpandedMain={setExpandedMain}
                                   setChangeIcon={setChangeIcon}/>
            </div>
        </div>
    );
}

export default LeftSideBar;
